import { useEffect, useState } from "react";

/**
{
  "letter": string, // C
  "list": {
    "name": string, // 中国
    "code": string // +86
  }[]
}[]
 */
const countriesJsonUrl = "https://cdn.dancf.com/gaodingx/assets/countries.json";

// 默认国家数据
const defaultCountries = [
  {
    name: "中国",
    code: "+86",
  },
  {
    name: "中国香港",
    code: "+852",
  },
  {
    name: "中国澳门",
    code: "+853",
  },
  {
    name: "中国台湾地区",
    code: "+886",
  },
];

// 缓存获取的数据，避免重复请求
let cachedCountries: Country[] | null = null;
let fetchPromise: Promise<Country[]> | null = null;

interface Country {
  name: string;
  code: string;
}

interface CountryGroup {
  letter: string;
  list: Country[];
}

export const useCountries = () => {
  const [countries, setCountries] = useState<Country[]>(defaultCountries);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // 如果已经有缓存数据，直接使用
    if (cachedCountries) {
      setCountries(cachedCountries);
      return;
    }

    // 如果正在获取数据，等待现有请求完成
    if (fetchPromise) {
      fetchPromise
        .then((data) => {
          setCountries(data);
        })
        .catch((err) => {
          setError(err.message);
        });
      return;
    }

    // 开始获取数据
    setLoading(true);
    fetchPromise = fetch(countriesJsonUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        // 合并默认数据和获取的数据，去重
        const mergedCountries: Country[] = [...defaultCountries];

        // 处理分组格式的数据
        if (Array.isArray(data)) {
          data.forEach((group: CountryGroup) => {
            if (group.list && Array.isArray(group.list)) {
              group.list.forEach((country) => {
                const exists = mergedCountries.some(
                  (defaultCountry) => defaultCountry.code === country.code
                );
                if (!exists) {
                  mergedCountries.push(country);
                }
              });
            }
          });
        }

        // 缓存结果
        cachedCountries = mergedCountries;
        setCountries(mergedCountries);
        setLoading(false);
        return mergedCountries;
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
        // 如果获取失败，使用默认数据
        setCountries(defaultCountries);
        console.warn(
          "Failed to fetch countries from URL, using default data:",
          err
        );
        return defaultCountries;
      })
      .finally(() => {
        fetchPromise = null;
      });
  }, []);

  return {
    countries,
    loading,
    error,
  };
};
